module.exports = " <div> Footer </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/FooterBar.vue
// module id = 389
// module chunks = 0